import watchFlagToggleRequested from './getFlagDataSaga';

export default [
  watchFlagToggleRequested(),
];
